import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../../api/api.service';
import { LocalserviceService } from '../../../api/localservice.service';

import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from "@angular/cdk/collections";

@Component({
  selector: 'app-showtable',
  templateUrl: './showtable.component.html',
  styleUrls: ['./showtable.component.css']
})
export class ShowtableComponent implements OnInit {

  public Args: any;
  public itiForm:any;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  public pduTable: any;
  public query: string = '';
  public page: number = 1;
  public offset: number = 5;
  public pageEvent: any;
  totallength:number = 1 ;

  public total_student:any ;
  public total_amount:any ;

  reciveiticode:any = window.localStorage.getItem('ITICode');

  displayedColumns = ['select', 'slno','regno', 'firstname', 'trade', 'exam'];
  SRC_SELECTED_FAMILYMEMBER: Element[] = [];
  DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
  dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
  selected_family_member = new SelectionModel<Element>(true, []);
  public int_index_edit: any;

  public showItiTableData:any;

  public bool_paynow:boolean  =true;

  reciveuserid:any;
  reciveMobilemo:any;
  reciveemail:any;
  reciveeITIcode:any;

  public itiHeaderName:any; 
  public itiHeaderemail:any; 
  public itiHeaderMobile:any; 
  public itiHeaderCode:any; 

  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router, private httpClient: HttpClient) { }

  ngOnInit(): void {

    this.itiForm = this.formBuilder.group({
      iticode: this.reciveiticode,
    });

    this.Args = {
      iticode: this.reciveiticode,
      query: '',
      page: '1',
      offset: '5',
    };


    alert(JSON.stringify(this.Args));

    this.api.showItiTable(this.itiForm.value).subscribe((result: any) => {
      console.log("result" + JSON.stringify(result));
                    this.showItiTableData = result;
      this.SRC_SELECTED_FAMILYMEMBER = result;
      this.DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
      this.dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
      //this.ngAfterViewInit();
      this.dataSource.paginator = this.paginator;        
      this.dataSource.sort = this.sort;
      // this.bool_itiForm = false;
      // this.bool_table = true;
      console.log(JSON.stringify(result));
      console.log(this.pduTable);
      this.totallength = result.length;
      console.log(JSON.stringify(result))
});

    // this.api.showItiTableLimit(this.Args).subscribe((result: any) => {
      
    //   this.showItiTableData = result;
    //   console.log(this.showItiTableData)
    //   this.SRC_SELECTED_FAMILYMEMBER = this.showItiTableData;
    //   this.DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
    //   this.dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
    //   //this.ngAfterViewInit();
    //   this.dataSource.paginator = this.paginator;        
    //   this.dataSource.sort = this.sort;
    //   // this.bool_itiForm = false;
    //   // this.bool_table = true;
    //   console.log(JSON.stringify(result));
    //   console.log(this.pduTable);
  
    //   this.api.showItiTableLimitCount(this.Args).subscribe((result: any) => {
    //     this.totallength = result[0]['count'];
    //     console.log(this.totallength);
    //   });
      
    // });
    
  }


  isAllSelected() {

    const numSelected = this.selected_family_member.selected.length;
    const numRows = this.dataSource.data.length;

//    console.log("numSelected : "+numSelected);
    
    this.total_student  = numSelected ;
    
    this.total_amount  = this.total_student * 376 ;
    console.log(this.total_student)
    
    if(this.total_student !== 0){
      this.bool_paynow = false;
    }
    else{
      this.bool_paynow = true;
    }

    //console.log(this.total_student)
    return numSelected === numRows;
  }

  masterToggle() {
    // this.isAllSelected() ?
    //     this.selected_family_member.clear() :
    //     this.dataSource.data.forEach(row => this.selected_family_member.select(row));

        if(this.isAllSelected()){
         // unsel 
          this.selected_family_member.clear() 
          this.total_student  = 0 ;
          this.total_amount  = this.total_student * 376 ;

          if(this.total_student !== 0){
            this.bool_paynow = false;
          }
          else{
            this.bool_paynow = true;
          }
        }
        else{
         //sel all
          this.dataSource.data.forEach(row => this.selected_family_member.select(row));
        }
  }
  public import_bool:boolean = false;

  onItiApiRefresh(){
    this.import_bool = true;
    alert(JSON.stringify(this.itiForm.value))

    this.api.checkApi(this.itiForm.value).subscribe((result: any) => {
      let Apidata = result;
      console.log('Apidata' + JSON.stringify(Apidata))
      if(result){        
        this.api.checkApiRefresh(Apidata).subscribe((result: any) => {
          this.api.showItiTable(this.itiForm.value).subscribe((result: any) => {
            this.showItiTableData = result;
            this.SRC_SELECTED_FAMILYMEMBER = result;
            this.DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
            this.dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
            //this.ngAfterViewInit();
            this.dataSource.paginator = this.paginator;        
            this.dataSource.sort = this.sort;
            // this.bool_itiForm = false;
            // this.bool_table = true;
            console.log(JSON.stringify(result));
            console.log(this.pduTable);
            this.totallength = result.length;
            console.log(JSON.stringify(result))
          });

        })
      }
      else{
        alert('No data Found')
      }
      
      // let Apidata = result;
      // let Olddata = this.showItiTableData;
      //       console.log('Apidata' + Apidata.length);
      //       console.log('old data' + Olddata.length);
            

    });
  }

  viewMaster(){
    this.router.navigateByUrl('/examfeeiti/examitipay');

  }

  pageChanged(event: any) {
    this.page = parseInt(event.pageIndex) + 1;
    this.offset = parseInt(event.pageSize);

    this.Args = {
      iticode: this.reciveiticode,
      query: '',
      page: this.page,
      offset: this.offset,
    };

    console.log(this.page + " , " + this.offset)
    this.api.showItiTableLimit(this.Args).subscribe((result: any) => {
      this.dataSource = new MatTableDataSource(result);
      console.log(JSON.stringify(result));

      
    })
  }
  
  public seltable:any =[];

  logSelection() {

    this.selected_family_member.selected.forEach((s)=>{   
      this.seltable.push(s);
      // this.seltable.concat(JSON.stringify({name: 'nantha'}));
    });
 
    this.seltable.forEach((value:any, key:any) => {
      value['comanId']={commanloginid: this.reciveuserid, commanlemail: this.reciveemail, commanlmobile: this.reciveMobilemo };
    });
    console.log(this.seltable);

    this.api.importTable(this.seltable).subscribe((result: any) => {
      // this.seltable = [];
      // this.selected_family_member.clear() 

      let status = result.status;
      if(status == 'sucess'){
        this.seltable.forEach((value:any, key:any) => {
          value['refid']=result.refid ;
        });
        console.log(this.seltable);

        this.api.importreTable(this.seltable).subscribe((result: any) => {
          let status = result.status;
          if(status == 'succes'){

            this.seltable = [];
          this.selected_family_member.clear();


          alert("Sucess")
      //       this.api.showItiTable(this.itiForm.value).subscribe((result: any) => {
      //         this.SRC_SELECTED_FAMILYMEMBER = result;
      //         this.DATA_SELECTED_FAMILYMEMBER = Object.assign(this.SRC_SELECTED_FAMILYMEMBER);
      //         this.dataSource = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER);
      //         //this.ngAfterViewInit();
      //         this.dataSource.paginator = this.paginator;        
      //         this.dataSource.sort = this.sort;
      //         console.log(JSON.stringify(result));
      //         console.log(this.pduTable);
      //         this.totallength = result.length;

      //         this.api.showItiMasterTable(this.itiForm.value).subscribe((result: any) => {

      //           this.itiHeaderName = result[0]['itiname'];
      //           this.itiHeaderemail = result[0]['itiemail'];
      //           this.itiHeaderMobile = result[0]['itimobile'];
      //           this.itiHeaderCode = result[0]['iticode'];

      //           alert("master Table")
      //           // this.SRC_SELECTED_FAMILYMEMBER_Master = result;
      //           // this.DATA_SELECTED_FAMILYMEMBER_Master = Object.assign(this.SRC_SELECTED_FAMILYMEMBER_Master);
      //           // this.dataSource_Master = new MatTableDataSource<Element>(this.DATA_SELECTED_FAMILYMEMBER_Master);
      //           // //this.ngAfterViewInit();
      //           // this.dataSource_Master.paginator = this.paginator_Master;        
      //           // this.dataSource_Master.sort = this.sort_Master;
      //           // this.bool_itiForm = false;
      //           // console.log(JSON.stringify(result));
      //           // console.log(this.pduTable);
      //           // this.totallength_master = result.length;
      //           // console.log(JSON.stringify(result));
      //           // this.bool_table = false;
      //           // this.bool_Master_table = true;
      //           });

        


      // });
          }
          else{
            
            this.seltable = [];
            this.selected_family_member.clear();
            
          }
        


 
        })

      }else{
      // this.seltable = [];
      // this.selected_family_member.clear() 
      }

    });

  }

  showOptions(event:any): void {
    console.log(event.checked);
}

}
